const allowedRoles = ['CO_ROLE', 'FOUNDER_ROLE', 'REGION_ROLE', 'ORGANIZATION_ROLE']
import {typesForKeycloak} from "@/controllers/UserController";

export default {
  namespaced: true,
  state: {
    keycloak: null,
    fakeUser: null,
    canEdit: true,
    currentYear: 2025,
    yearsApiPath: {
      2022: '',
      2023: '',
      2025: ''
    }
  },
  mutations: {
    ['SET_AUTH_DATA'](state, data) {
      state.keycloak = data;
    },
    ['INIT_FAKE_USER'](state, data) {
      state.fakeUser = data;
    },
    ['EDIT_ALLOWED'](state, data) {
      state.canEdit = data;
    },
    ['EDIT_CURRENT_YEAR'](state, payload) {
      state.currentYear = payload;
    }
  },
  actions: {
    setAuthData({commit, dispatch, getters}, payload) {
      commit('SET_AUTH_DATA', payload);
      //downloads spr for co and regions
      if (getters.isCO || getters.isRegion || getters.isAdminGroup) {
        dispatch('spr/getCOsFromServer', null, {root: true});
        dispatch('spr/getRegionsFromServer', null, {root: true});
        dispatch('spr/getSprUsls', null, {root: true});
      }
      //downloads for adminGroup
      if (getters.isAdminGroup) {
        dispatch('spr/getKcpGroupsFromServer', null, {root: true});
      }

      if (getters.isAdminGroup || getters.isOrganization) {
        dispatch('spr/getAllOrganizations', null, {root: true});
      }
      //downloads for organizations
      if (getters.isOrganization) {
        dispatch('spr/getSprForOrganization', null, {root: true});
        if (getters.userId) {
          dispatch('spr/getOrgByOwner', null, {root: true});
        }
      }
      if (getters.isFounder && !getters.isAdminGroup)
        dispatch('spr/getSprUsls', null, {root: true});
      //downloads for Co Regions and organizations
      if ((!getters.isFounder || getters.isCO || getters.isAdminGroup)/* && !getters.isAdminGroup*/) {
        dispatch('spr/getKcpGroupsFromServer', null, {root: true});
        dispatch('checkFilled/loadingFiles', null, {root: true});
      }
      //info for show some blocks
      if (!getters.isAdmin || (getters.isAdmin && getters.getFakeUser)) {
        dispatch('checkFilled/loadingBlockInfo', null, {root: true});
      }
      dispatch('checkFilled/getAdminInfoBlock', null, {root: true});
    },
    async keycloakLogout({commit, state}) {
      if (state.keycloak) {
        await localStorage.removeItem('vuex');
        await state.keycloak.logout();
        commit('SET_AUTH_DATA', null)
      }
    },
    async initFakeUser({commit}, payload) {
      commit('INIT_FAKE_USER', payload)
    },
    async clearFakeUser({commit}) {
      commit('INIT_FAKE_USER', null)
    },
  },
  getters: {
    getKeycloakData(state) {
      return state.keycloak
    },
    getAuthData(state) {
      return state.keycloak?.tokenParsed
    },
    userId(state, getters) {
      let userIdName;
      Object.entries(typesForKeycloak).forEach(([key, value]) => {
        if (value.roles.includes(getters.currentRole))
          userIdName = key
      })
      return state.fakeUser?.id ? state.fakeUser?.id : state.keycloak?.tokenParsed[userIdName]
      // return state.keycloak?.tokenParsed?.founderID ? state.keycloak?.tokenParsed?.founderID : state.keycloak?.tokenParsed?.regionID ? state.keycloak?.tokenParsed?.regionID : state.fakeUser?.id;
    },
    getRoles(state) {
      return state.keycloak?.realmAccess?.roles.filter(el => el !== 'default-roles-ppk_sso') ?? []
    },
    getFakeUser(state) {
      return state.fakeUser
    },
    isAdmin(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'ADMIN_ROLE')
    },
    isAdminGroup(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'ADMIN_ROLE' || el === 'REGION_ADMIN_ROLE')
    },
    isDisabledEnter(state) {
      return !state.canEdit
    },
    isRegion(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'REGION_ROLE')
    },
    isCO(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'CO_ROLE')
    },
    isFounder(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'FOUNDER_ROLE')
    },
    isOrganization(state) {
      return !!state.keycloak?.realmAccess?.roles.find(el => el === 'ORGANIZATION_ROLE')
    },
    currentRole(_, getters) {
      if (getters.getFakeUser?.role) {
        return getters.getFakeUser?.role
      } else if (getters.getRoles.includes('ADMIN_ROLE')) {
        return 'ADMIN_ROLE'
      } else {
        return getters.getRoles.find((el) => {
          return allowedRoles.includes(el)
        }, '');
      }
    },
    currentApiYear(state) {
      return state.yearsApiPath[state.currentYear]
    }
  }
}